import { insertHtmlFragment } from '@otto-ec/global-resources/dom';

export class Appventskalender {
    async init() {
        const appventskalenderElement: HTMLElement | null = document.querySelector(
            '.promo_staticcontent--appventskalender',
        );
        if (appventskalenderElement) {
            await fetch('/appventskalender/index.html')
                .then((response) => {
                    if (response.ok) {
                        return response.text();
                    } else {
                        throw new Error('[FT3] Appventskalender loading failed.');
                    }
                })
                .then((appventskalenderHtml) => insertHtmlFragment(appventskalenderHtml, appventskalenderElement))
                .catch((error) => console.error(error.message));
        } else {
            console.error('[FT3] Appventskalender element not found.');
        }
    }
}
